import React from "react";
import "./emailBuilderSkeleton.scss";

interface IEmailBuilderSkeletonProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  /** Reserves a text line box (1lh) with a 1em-tall bar; numeric width is in ch. */
  text?: boolean;
}

export function EmailBuilderSkeleton(props: IEmailBuilderSkeletonProps) {
  if (props.text === true) {
    const width =
      typeof props.width === "number" ? `${props.width}ch` : props.width ?? "8ch";

    return (
      <span
        className={
          props.className !== undefined
            ? `email-builder-skeleton-text ${props.className}`
            : "email-builder-skeleton-text"
        }
      >
        <span className="email-builder-skeleton" style={{ width, height: "1em" }} />
      </span>
    );
  }

  const style: React.CSSProperties = {};
  if (props.width !== undefined) {
    style.width = typeof props.width === "number" ? `${props.width}px` : props.width;
  }
  if (props.height !== undefined) {
    style.height = typeof props.height === "number" ? `${props.height}px` : props.height;
  }

  return (
    <div
      className={
        props.className !== undefined
          ? `email-builder-skeleton ${props.className}`
          : "email-builder-skeleton"
      }
      style={style}
    />
  );
}
